import { ArrowUpRight } from "lucide-react";
import { ADDRESS_ONE_LINE, BUSINESS, MAPS_URL } from "@/lib/site";
import { trackEvent } from "@/lib/analytics";
import { Reveal } from "../Reveal";

const EMBED_SRC = `https://www.google.com/maps?q=${encodeURIComponent(
  `${BUSINESS.name}, ${ADDRESS_ONE_LINE}`,
)}&output=embed`;

export function ContactMap() {
  return (
    <Reveal className="mt-12">
      <div className="overflow-hidden rounded-sm border border-sand/70 bg-surface">
        <div className="flex flex-wrap items-end justify-between gap-4 border-b border-sand/60 px-5 py-4">
          <div>
            <p className="font-display text-xl text-forest-deep">{BUSINESS.name}</p>
            <p className="mt-1 text-sm text-muted-foreground">{ADDRESS_ONE_LINE}</p>
          </div>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="link-underline text-sm font-semibold text-forest"
            onClick={() => trackEvent("directions_clicked", { location: "contact_map" })}
          >
            Get Directions <ArrowUpRight className="size-4" aria-hidden="true" />
          </a>
        </div>
        <iframe
          title={`Map showing ${BUSINESS.name} at ${ADDRESS_ONE_LINE}`}
          src={EMBED_SRC}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="aspect-[16/10] w-full border-0"
        />
      </div>
    </Reveal>
  );
}
